import OrderPageOffers from "@/services/orderPageOffers";
import { useUpselledStore } from "@/store/upselled";

/**
 * Resout l'URL d'image d'une offre pour l'order page et le panier.
 * Priorite : initialChoices.image > parent upsell > images produit.
 */
export default class ChoiceImage {
  static getInitialChoiceImage(choiceId, productDetails) {
    if (!choiceId || !productDetails?.initialChoices) {
      return null;
    }

    for (const choiceGroup of productDetails.initialChoices) {
      for (const choice of choiceGroup) {
        if (String(choice.id) === String(choiceId) && choice.image) {
          return choice.image;
        }
      }
    }

    return null;
  }

  static getUpselledChoiceImage(currentChoice, productDetails) {
    if (!currentChoice || !productDetails?.upsells) {
      return null;
    }

    const downgradeChoice =
      useUpselledStore().getDowngradeChoice(currentChoice);
    if (!downgradeChoice) {
      return null;
    }

    const upsellWithParent = OrderPageOffers.findQuicksellEntry(
      downgradeChoice.id,
      productDetails,
    );
    if (upsellWithParent) {
      for (const childGroup of upsellWithParent.children) {
        for (const child of childGroup) {
          if (child.id === currentChoice.id && child.image) {
            return child.image;
          }
        }
      }
    }

    return this.getInitialChoiceImage(downgradeChoice.id, productDetails);
  }

  static getProductListImage(entity, { isProductListFromParent = false } = {}) {
    const featuredImage = entity?.images?.find(
      (image) => image.type === "featuredImage",
    );
    if (!isProductListFromParent && featuredImage?.src) {
      return featuredImage.src;
    }

    const mainImage = entity?.images?.find((image) => image.type === "main");
    return mainImage?.src || null;
  }

  static getChoiceImageSrc(entity, productDetails, options = {}) {
    if (!entity) {
      return null;
    }

    const choice = options.choice || entity.choice;
    const choiceId = choice?.id;

    const initialImage = choiceId
      ? this.getInitialChoiceImage(choiceId, productDetails)
      : null;
    if (initialImage) {
      return initialImage;
    }

    if (choice) {
      const upsellImage = this.getUpselledChoiceImage(choice, productDetails);
      if (upsellImage) {
        return upsellImage;
      }
    }

    return this.getProductListImage(entity, options);
  }
}
